export default __webpack_public_path__ + "static/media/rainbow.de61359f.png";